module.exports = __webpack_public_path__ + "img/8.975a2df4.png";